module.exports = __webpack_public_path__ + "static/media/affordable.5048b2c1.svg";